import React from 'react';
import { Card } from 'antd';
import { EyeInvisibleFilled, UserOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { listarAtendente } from 'routes/paths';
import { fetchGetAtendenteById } from 'store/fetchActions/fetchAtendente';
import * as S from '../styles';
import { useDispatch } from 'react-redux';

export default function CardAtendenteSetor({ atendentes }) {
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <Card
      title="Atendentes do Setor"
      extra={<S.LinkAtendente onClick={() => history.push(listarAtendente)}>Todos os Atendentes</S.LinkAtendente>}
      style={{ width: '100%', marginTop: '20px' }}
    >
      {atendentes?.map(atendente => {
        return (
          <S.AtendenteDescricao
            key={atendente?.id}
            onClick={() => dispatch(fetchGetAtendenteById(atendente?.id, history))}
          >
            <UserOutlined /> {atendente?.nome}
          </S.AtendenteDescricao>
        );
      })}
      {atendentes?.length === 0 && (
        <S.AtendentesRowEmpty>
          <EyeInvisibleFilled /> Nenhum Atendente Vinculado ao Setor
        </S.AtendentesRowEmpty>
      )}
    </Card>
  );
}
